import { NavLink, Link } from 'react-router-dom';
import { site } from '../config/site.js';
import { useAuth } from '../auth/AuthContext.jsx';

const initials = (name) =>
  name.replace(/[^A-Za-z0-9 ]/g, '').split(/\s+/).map((w) => w[0]).join('').slice(0, 2).toUpperCase();

const linkKlasse = ({ isActive }) => `nav__link${isActive ? ' nav__link--active' : ''}`;

export default function AppShell({ children }) {
  const { user, logout } = useAuth();

  return (
    <div className="shell">
      <header className="topbar">
        <div className="container topbar__inner">
          <Link to="/" className="brand">
            {/* Kuerzel wird aus dem Namen abgeleitet, damit auch das Logo
                bei einer Umbenennung automatisch mitgeht. */}
            <span className="brand__mark">{initials(site.nameShort || site.name)}</span>
            <span className="brand__name">{site.name}</span>
          </Link>

          <nav className="nav">
            <NavLink to="/" end className={linkKlasse}>Heute</NavLink>
            <NavLink to="/events" className={linkKlasse}>Events</NavLink>
            <NavLink to="/raids" className={linkKlasse}>Raids</NavLink>
            <NavLink to="/pokemon" className={linkKlasse}>Pokémon</NavLink>
            <NavLink to="/fangen" className={linkKlasse}>Fangen</NavLink>
            <NavLink to="/pvp" className={linkKlasse}>PvP</NavLink>
            <NavLink to="/mein-bereich" className={linkKlasse}>Dein Bereich</NavLink>

            {user ? (
              <button type="button" className="nav__link nav__link--knopf" onClick={logout}>
                Abmelden
              </button>
            ) : (
              <NavLink to="/konto" className={linkKlasse}>Anmelden</NavLink>
            )}

            <NavLink to="/admin" className={linkKlasse}>Admin</NavLink>
          </nav>
        </div>
      </header>

      <main className="page">
        <div className="container">{children}</div>
      </main>

      <footer className="footer">
        <div className="container">
          {site.name} — Arbeitstitel, inoffizielles Fanprojekt. Keine Verbindung zu Niantic oder Nintendo.
        </div>
      </footer>
    </div>
  );
}
